import React, { Profiler, useEffect, useState } from "react";
import {
  MdDelete,
  MdKeyboardArrowRight,
  MdOutlineModeEdit,
  MdSearch,
} from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import Header from "../../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../../Components/Dashboard/Sidebar/Sidebar";
import Loader from "../../../../Components/loader/loader";
import { useNavigate } from "react-router-dom";
import userprofileimg from "../../../../Assets/Images/userprofileimg.jpg";
import { FiDownload } from "react-icons/fi";
import "../ResumeDisplay/ResumeDisplay.css";
import { Apiurl, GetToken } from "../../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import Select from "react-select";
const ResumeDisplay = () => {
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  const firstDateOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const minDate = firstDateOfMonth.toISOString().split("T")[0];
  currentDate.setDate(currentDate.getDate() - 45);
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [leaveRequest, setLeaveRequest] = useState();
  const [showImageModal, setShowImageModal] = useState(false);
  const LoginToken = GetToken();
  const [cvAllData, setCVAllData] = useState([]);
  const [deleteItem, setDeleteItem] = useState(null);
  const [departmentData, setDepartmentData] = useState([]);
  const [departmentId, setDepartmentId] = useState("");

  const [PagesNumber, setPagesNumber] = useState([]);
  const [handelSearchData, setHandelSearchData] = useState("");
  const [expreinceeuserData, setExpreinceeuserData] = useState("");

  const [FilterData, setFilterData] = useState({
    Category: "",
    Experience: "",
  });
  const handleClose = () => setShowImageModal(false);
  const handleShow = () => setShowImageModal(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleResumeDisplay();
    }, 1000);
    return () => clearTimeout(timer);
  }, [FilterData]);

  // const handleResumeDisplay = () => {
  //   setLoading(true);
  //   const option = {
  //     method: "GET",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       authorization: `Bearer ${LoginToken}`,
  //     },
  //     url: `https://attendanceapi.elitewebdemo.com/api/Cv/GetAllCvs`,
  //   };
  //   axios(option)
  //     .then((e) => {
  //       setLoading(false);
  //       const data = JSON.parse(e?.data?.data);
  //       setCVAllData(data);
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // };
  const handleOpenModal = (item) => {
    setDeleteItem(item);
    setShowImageModal(true);
  };
  // display user data
  const handleResumeDisplay = (e) => {
    setLoading(true);
    const data = {};
    data.Experience = FilterData?.Experience;
    data.Category = FilterData?.Category;
    data.pageNo = "1";
    data.pageSize = "10";
    // const pageValue = e?.pageSize.length / 10;
    // const maxNumber = Math.ceil(pageValue);
    // const numbers = [];
    // for (let i = 1; i <= maxNumber; i++) {
    //   numbers.push(i);
    // }
    // setPagesNumber(numbers);

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `https://attendanceapi.elitewebdemo.com/api/Cv/FilterCvList`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          const responceData = e?.data?.filteredCvs;
          // const verifyData = JSON.parse(responceData);
          // const data = JSON.parse(e?.data?.data);
          setCVAllData(responceData);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    handleResumeDisplay();
  }, []);
  // delete userdata Api
  const handleDeleteResume = (deleteItem) => {
    const data = {};
    data.Id = deleteItem.Id;
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `https://attendanceapi.elitewebdemo.com/api/Cv/DeleteCV`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setShowImageModal(false);
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          handleResumeDisplay();
        }
      })
      .catch((error) => {
        setShowImageModal(false);
        setLoading(false);
      });
  };
  // send prefiled data
  const handelEditTableData = (item) => {
    navigate("/Emp/ResumeUpload", { state: item });
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      handleResumeDisplay();
    }, 1000);
    return () => clearTimeout(timer);
  }, [handelSearchData]);

  const getDepartment = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetDepartments`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        const finalData = data?.map((item) => ({
          label: item?.Name,
          value: item?.Id,
        }));
        setDepartmentData(finalData);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getDepartment();
  }, []);

  const handleDepartmentChange = (selectedOption) => {
    setDepartmentId(selectedOption?.value);
    setFilterData({ ...FilterData, Category: selectedOption?.value });
  };
  const handleUserExperiences = (selectedOption) => {
    setFilterData({ ...FilterData, Experience: selectedOption?.Id });
  };
  const GetUserExperiences = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `https://attendanceapi.elitewebdemo.com/api/Cv/GetExperiences`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setExpreinceeuserData(data.Result);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    GetUserExperiences();
  }, []);

  const handleDataSearch = (e) => {
    const searchTerm = e?.target?.value?.toLowerCase();
    if (searchTerm) {
      const filteredData = cvAllData?.filter((item) => {
        return item?.Name?.toLowerCase()?.includes(searchTerm);
      });
      setCVAllData(filteredData);
    } else {
      handleResumeDisplay();
    }
  };
  const downloadFile = async (FileDownloadUrl) => {
    try {
      const response = await fetch(FileDownloadUrl);
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const fileName = FileDownloadUrl.substring(
        FileDownloadUrl.lastIndexOf("/") + 1
      );
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const check = (item) => {
    const NewFile = item.FileDownloadUrl;
    downloadFile(NewFile);
  };

  const handleDownload = (fileUrl, fileName) => {
    const pdfUrl = fileUrl;
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "document.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <div
            className={
              showSidebar
                ? "EMP-main-container-of-all-employees-sheet-hr"
                : "EMP-main-container-of-all-employees-page-new-sheet"
            }
          >
            <div className="EMP-report-all-icons">
              <div>
                <p className="MAIN-HEADING">
                  Resume Data
                  {/* {leaveRequestData ? "Edit Leaves" : "Apply Leaves"} */}
                </p>
              </div>
              <div className="dashboiard-inner-header">
                <BiHomeAlt className="EMP-home-icon-header-inn" />
                <MdKeyboardArrowRight />
                <p> Resume Data </p>
                <MdKeyboardArrowRight />
                <p>Resume Data</p>
              </div>
            </div>
            <div className="EMP-body-part-outer-container">
              <div className="EMP-inner-body-container-of-employee-table row-12">
                <div className="Resume-display-table-header">
                  <div className="EMP-employee-text-in-body">
                    <h2>Resume Data</h2>
                  </div>
                  <div className="coustom-search-data">
                    <MdSearch className="EMP-search-icon-in-input" />
                    <input
                      type="text"
                      placeholder="Search"
                      onChange={(e) => handleDataSearch(e)}
                    />
                  </div>
                  <div className="Search-Filter-of-userCv-data-table">
                    <Select
                      classNamePrefix="search-Filter-Category"
                      placeholder="Category"
                      options={departmentData}
                      getOptionLabel={(options) => options?.label}
                      getOptionValue={(options) => options?.value}
                      value={
                        FilterData?.UserRole?.RoleName === "HR"
                          ? departmentData.find(
                              (department) => department.label === "Management"
                            )
                          : FilterData?.Department
                      }
                      onChange={handleDepartmentChange}
                    />
                  </div>
                  <div className="Search-Filter-of-userCv-data-table-expreinceeuserData">
                    <Select
                      classNamePrefix="search-Filter-Category"
                      placeholder="Experience "
                      options={expreinceeuserData}
                      getOptionLabel={(options) => options?.Name}
                      getOptionValue={(options) => options?.Id}
                      onChange={handleUserExperiences}
                    />
                  </div>
                </div>
              </div>
              <div className="main-class-for-table-in-admin">
                <table className="table-of-employee-leaves table-of-admin-report">
                  <thead className="thead-of-emp-table-leaves">
                    <tr className="">
                      <th className="approve_Date-display"> Sr. no</th>
                      <th className="approve_Date-display"> Name</th>
                      <th className="approve_Date-display">Phone</th>
                      <th className="approve_Date-display">Email</th>
                      <th className="approve_Date-display">Category</th>
                      <th className="approve_Date-display">Sub-Category</th>
                      <th className="approve_Date-display">Experience</th>
                      <th className="approve_Date-display">Skills</th>
                      <th className="approve_Date-display">CV</th>
                      <th className="approve_Date-display">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-ofemp-table-leaves">
                    {cvAllData?.map((item, index) => (
                      <tr key={index}>
                        <td> {index + 1}</td>
                        <td>{item?.name}</td>
                        <td>{item?.phone}</td>
                        <td>{item?.email}</td>
                        <td>{item?.categories?.name}</td>
                        <td>{item?.subCategories?.designationName}</td>
                        <td>{item?.experiences?.name}</td>
                        <td>{item?.skills}</td>
                        <td
                          className="slip-downloard"
                          onClick={() =>
                            handleDownload(item?.fileDownloadUrl, "cv.pdf")
                          }
                        >
                          <a className="Downloard-cv-icon">
                            <FiDownload />
                          </a>
                        </td>
                        <td className="">
                          <MdOutlineModeEdit
                            onClick={() => handelEditTableData(item)}
                            className="handel-Edit-button"
                          />
                          <MdDelete
                            className="handel-delete-button"
                            onClick={() => handleOpenModal(item)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div></div>
              </div>
            </div>
          </div>
        </>
      </div>
      <Modal show={showImageModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Delete Resume Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteItem && (
            <div>
              <p>Name: {deleteItem?.Name}</p>
              <p>Phone: {deleteItem?.Phone}</p>
              <p>Email: {deleteItem?.Email}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="close_button-of-Resume" onClick={handleClose}>
            Close
          </Button>
          <Button
            className="DeleteButton-ofResume"
            onClick={() => handleDeleteResume(deleteItem)}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ResumeDisplay;
